module.exports = __webpack_public_path__ + "img/history_dark.53f120e6.png";